import { useMsal } from "@azure/msal-react";
import { useEffect, useState } from "react";
import useFetching from "../services/cardService";

export function useAdminStatus() {
  const [isAdmin, setIsAdmin] = useState(null);
  const { getAccountInfo } = useFetching();
  const instance = useMsal();

  useEffect(() => {
    async function fetchAccountInfo() {
      const response = await getAccountInfo();
      const role = response.jobTitle;
      // Für debug
      //const role = "Prokurist / Managing Consultant";

      if (
        role.toUpperCase().includes("MANAGING CONSULTANT") ||
        role.toUpperCase().includes("GESCHÄFTSFÜHRER") ||
        role.toUpperCase().includes("PROKURIST")
      ) {
        setIsAdmin(true);
      } else {
        setIsAdmin(false);
      }
    }
    try {
      fetchAccountInfo();
    } catch (error) {
      console.error(error.message);
    }
  }, [instance]);

  return isAdmin;
}
